import { render } from "./HeroiconsOutlineClipboard.vue?vue&type=template&id=2b3425f6"
const script = {}

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineClipboard.vue"]])

export default __exports__